export const productLink = (href, vendor) => {
  let domainWithoutSubdomain = 'rootdomain.com:3000';
  if (typeof window !== 'undefined') {
    domainWithoutSubdomain = getDomainWithoutSubdomain();
  }

  // Map vendors to their subdomains
  const vendors = {
    orca: 'orcacoolers',
    gci: 'gcioutdoor',
    klymit: 'klymit',
  };

  let baseUrl = `${vendors[vendor]}.${domainWithoutSubdomain}`;
  let protocol;
  // Determine the protocol based on the vendor
  if (domainWithoutSubdomain === 'rootdomain.com:3000') {
    protocol = 'http';
  } else {
    protocol = 'https';
  }

  // Construct the full URL
  return `${protocol}://${baseUrl}${href}`;
};

// // Usage example
// const url = productLink('/products/chaser', 'orca');
// console.log(url);

function getDomainWithoutSubdomain() {
  const hostname = window.location.hostname;
  const port = window.location.port ? ':' + window.location.port : '';
  const parts = hostname.split('.').reverse();

  let domainWithoutSubdomain;
  if (parts.length > 2) {
    // Check for country code suffixes like '.co.uk'
    if (parts[1].length === 2 || parts[0].length === 2) {
      domainWithoutSubdomain = `${parts[2]}.${parts[1]}.${parts[0]}`;
    } else {
      domainWithoutSubdomain = `${parts[1]}.${parts[0]}`;
    }
  } else {
    domainWithoutSubdomain = hostname;
  }

  return domainWithoutSubdomain + port;
}
